import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';



import 'survey-core/defaultV2.min.css';
import './index.css';
import './i18n';
import './i18n/surveyCore';
import App from './App';
import { ReferralProvider } from './referral';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
// @ts-ignore
import awsmobile from './aws-exports';

// QA/preview shortcut: `/?debug=<experiment>` forces an arm, seeds a qualifying
// profile, and jumps to the screen that experiment changes. See debugExperiment.ts.
import { maybeActivateDebugExperiment } from './debugExperiment';
import { syncWeb29OfferFromLocation } from './web29Offer';
import { syncBfSalePreviewFromLocation } from './bfSale';
import { captureShareLink } from './shareLink';
import { getExplicitLanguage } from './i18n/language';
import { initTikTokPixel } from './services/tiktokPixel';
import { captureLpHandoff } from './utils';
import { adoptLpSessionId } from './hooks/useAnswerTracker';
maybeActivateDebugExperiment();
// web29 legit timer: `?offer=email` (email retarget links) revives the anchor
// arm's offer on any entry URL. Runs after the debug activation so the QA knobs
// (?offer=expired / ?offer=reset) see the forced experiment.
syncWeb29OfferFromLocation(window.location.search);
// Black Friday 2026: `?preview=bf-early` / `?preview=bf-off` for this session.
syncBfSalePreviewFromLocation(window.location.search);
// Sharing measurement: `?s=<share id>` on any entry URL.
captureShareLink();
// bws-lp landing experiments (kelly_funnel): `?lp=&cell=&sid=` on the handoff
// URL. Keep the cell and continue the container's SessionIdentity row before
// the quiz's first redirect drops the query string.
captureLpHandoff();
adoptLpSessionId();
// Spanish quiz: `?lang=es|en` on any entry URL is saved before the quiz's
// first redirect drops the query string.
getExplicitLanguage();
// TikTok pixel: no-op unless REACT_APP_TIKTOK_PIXEL_ID is set at build time.
initTikTokPixel();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

//Amplify.configure(awsmobile);


/*
const myStatsigClient = new StatsigClient(
  STATSIG_CLIENT_KEY, { 
    customIDs: {
      stableID:  Cookies.get('bws_statsig_stable_id')
    }
}
 ,
  { 
    environment: {
      tier: process.env.NODE_ENV,
    },
  } 
);

// initialize and wait for the latest values
myStatsigClient.initializeAsync().then(() => {
  Cookies.set('bws_statsig_stable_id', myStatsigClient.getContext().stableID, {
    expires: 365,
    sameSite: 'lax',
    domain: process.env.NODE_ENV === 'development' ? 'localhost' : 'builtwithscience.com',
  });
  const quizEventData: QuizEventData = {
    event: 'quiz',
    funnel_variation: FunnelVariation.General,
    quizz_name: 'New Onboarding Quiz',
    quizz_step: '0',
    quizz_step_name: 'Start',
    quizz_version: getVersionNumber(),
  };
  pushToDataLayer(quizEventData);
  myStatsigClient.logEvent('quiz', '0', {
    funnel_variation: FunnelVariation.General,
    step_name: 'Start',
  });
    //console.log(CheckStripeExperiment());
    const amplitudeDeviceId = uuidv4();
    Cookies.set('bws_amplitude_device_id', amplitudeDeviceId, {
      expires: 365,
      sameSite: 'lax',
      domain: process.env.NODE_ENV === 'development' ? 'localhost' : 'builtwithscience.com',
    });
    amplitude.init(AMPLITUDE_API_KEY, undefined, {
      deviceId: amplitudeDeviceId,
      autocapture: true
     
    });
    amplitude.track('quiz', {
      step: '0',
      step_name: 'Start',
      funnel_variation: FunnelVariation.General,
    });
  
});




/*
Statsig.initialize(
  STATSIG_CLIENT_KEY,
  {},
  {
    overrideStableID: Cookies.get('bws_statsig_stable_id'),
    environment: {
      tier: process.env.NODE_ENV,
    },
  }
).then(() => {
  Cookies.set('bws_statsig_stable_id', Statsig.getStableID(), {
    expires: 365,
    sameSite: 'lax',
    domain: process.env.NODE_ENV === 'development' ? 'localhost' : 'builtwithscience.com',
  });
  const quizEventData: QuizEventData = {
    event: 'quiz',
    funnel_variation: FunnelVariation.General,
    quizz_name: 'New Onboarding Quiz',
    quizz_step: '0',
    quizz_step_name: 'Start',
    quizz_version: getVersionNumber(),
  };
  pushToDataLayer(quizEventData);
  Statsig.logEvent('quiz', '0', {
    funnel_variation: FunnelVariation.General,
    step_name: 'Start',
  });
    //console.log(checkStripeExperiment());
    const amplitudeDeviceId = uuidv4();
    Cookies.set('bws_amplitude_device_id', amplitudeDeviceId, {
      expires: 365,
      sameSite: 'lax',
      domain: process.env.NODE_ENV === 'development' ? 'localhost' : 'builtwithscience.com',
    });
    amplitude.init(AMPLITUDE_API_KEY, undefined, {
      deviceId: amplitudeDeviceId,
      autocapture: true
     
    });
    amplitude.track('quiz', {
      step: '0',
      step_name: 'Start',
      funnel_variation: FunnelVariation.General,
    });
  
});
*/


root.render(
  <React.StrictMode>
    <Router>
      <ReferralProvider><App /></ReferralProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
